import { Box, Text } from '@chakra-ui/react';
import { keyframes } from '@emotion/react';

interface LoadingSpinnerProps {
  message: string;
}

const pulse = keyframes`
  0% { opacity: 1; }
  50% { opacity: 0.4; }
  100% { opacity: 1; }
`;

const pulseAnimation = `${pulse} 2s ease-in-out infinite`;

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ message }) => {
  return (
    <Box
      position="fixed"
      top="30%"
      left="50%"
      transform="translate(-50%, -50%)"
      textAlign="center"
      border="1px solid"
      borderColor="accent.500"
      borderRadius="xl"
      p={4}
      bg="gray.800"
      boxShadow="0 0 20px rgba(255, 152, 0, 0.1)"
      backdropFilter="blur(4px)"
      zIndex={1000}
    >
      <Text
        color="accent.400"
        fontSize="lg"
        animation={pulseAnimation}
        textShadow="0 0 10px var(--chakra-colors-accent-400)"
      >
        {message}
      </Text>
    </Box>
  );
};

export default LoadingSpinner; 